export const shouldShowDiscountColumn = (document = {}, items = []) =>
  Boolean(document.showDiscount) ||
  String(document.discountCheck || document.discountColumn || "").toUpperCase() === "YES" ||
  (items || []).some(
    (item) =>
      item.discount !== undefined &&
      item.discount !== null &&
      String(item.discount).trim() !== ""
  );
